
import { Options, Vue } from 'vue-class-component';
import Modal from "@/components/common/Modal.vue";
import api from "@/shared/api";
import session from "@/shared/session";

type Env = {
    name: string;
    key: string;
    redirect_uri: string;
};

@Options({
    components: {Modal}
})
export default class PurchaseLoginOrRegister extends Vue {
    protected ready = false;
    protected environments: Env[] = [];
    protected selectedEnv: Env|null = null;
    protected error = '';
    protected email = '';
    protected password = '';
    protected acceptedTerms = false;
    protected termsDocumentUrl = '';
    protected termsDocumentVersion = '';

    get termsUrl(): string {
        return this.termsDocumentUrl || 'https://raffishagency.com/';
    }

    async created() {
        try {
            const [environments, termsResponse] = await Promise.all([
                api.getSprinklrEnvironments(),
                api.getConsentTerms(),
            ]);
            this.environments = environments;
            this.termsDocumentUrl = termsResponse.terms.documentUrl;
            this.termsDocumentVersion = termsResponse.terms.documentVersion;
        } catch (e) {
            console.error(e);
            this.error = 'Could not load registration options.';
        }
        this.ready = true;

        session.checkSession().then(
            (loggedIn) => {
                if (loggedIn) {
                    this.$router.push('/installedapps');
                }
            },
        );
    }

    async openSprinklr(env: Env) {
        if (!env || !this.acceptedTerms || !this.termsDocumentUrl || !this.termsDocumentVersion) {
            return;
        }

        this.error = '';

        // Create order first
        const voucherMatch = window.location.href.match(/(\?|&)voucher=([a-zA-Z0-9]+)/);
        const voucher = voucherMatch ? voucherMatch[2] : '';

        try {
            const orderData = await api.createOrder(this.$route.params.appname as string, voucher, {
                accepted: true,
                documentUrl: this.termsDocumentUrl,
                documentVersion: this.termsDocumentVersion,
            });
            if (orderData.error) {
                this.error = orderData.error;
                return;
            }

            const orderId = orderData.orderId;
            const appStoreEnv = window.location.port !== '443' && window.location.port !== '' ? 'development' : 'prod';
            const state = appStoreEnv + '-order-' + orderId;
            const redirect_uri = env.redirect_uri;
            const client_id = env.key;

            window.location.href =
                'https://api2.sprinklr.com/' +
                env.name +
                '/oauth/authorize?client_id=' +
                client_id +
                '&response_type=code&redirect_uri=' +
                redirect_uri +
                '&state=' +
                state;
        } catch (e: unknown) {
            this.error = e instanceof Error ? e.message : 'Could not start registration.';
        }
    }

    async login() {
        this.error = '';
        try {
            const data = await api.authLogin(this.email, this.password);
            console.log('login result', data);
            if (data.error) {
                this.error = data.error;
            } else {
                await session.setTokens(data);
                await this.$router.push({ name: 'app-details', params: { appname: this.$route.params.appname } });
            }
        } catch (error) {
            console.error(error);
            if (String(error).includes('401')) {
                this.error = "Invalid Username or Password 😔"
            }
            else {
                this.error = String(error).toString()
            }
            this.email = '';
            this.password = '';
        }
    }
}
